import api from '@/api/clips'
import errors from '@/api/errors'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  /**
   * クリップ登録
   */
  clipReview: ({ dispatch }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      reviewId: args.reviewId
    }
    return api.clipReview(params).then(data => {
      dispatch('storeReviews/setEntryClip', {
        reviewId: args.reviewId,
        isEntryClip: 1, // 1:クリップ登録済み
        clipId: data.clip_id
      }, { root: true }).then(() => {
        dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      })
    }).catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  /**
   * クリップ解除
   */
  unclipReview: ({ dispatch }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      clipId: args.clipId
    }
    return api.unclipReview(params).then(data => {
      if (args.isRemoved) {
        dispatch('storeReviews/removeReviewInternal', {
          reviewId: args.reviewId
        }, { root: true }).then(() => {
          dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
        })
      } else {
        dispatch('storeReviews/setEntryClip', {
          reviewId: args.reviewId,
          isEntryClip: 0 // 0:クリップ未登録
        }, { root: true }).then(() => {
          dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
        })
      }
      return data
    }).catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/clips.js